import { invokeApi } from "../../bl_libs/invokeApi";

export const memberDetail = async () => {
  const requestObj = {
    path: `api/member/profile`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const dashboardDetail = async () => {
  const requestObj = {
    path: `api/dashboard/dashboard_for_client`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const ProjectInfoApi = async () => {
  const requestObj = {
    path: `api/member_init`,
    method: "GET",
    headers: {
      // "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const EditProfileApi = async (data) => {
  const requestObj = {
    path: `api/member/edit_member_profile`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const subscriptionsDetailApi = async (id) => {
  const requestObj = {
    path: `api/member/subscription/details/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const getSubscriptionsListApi = async (data) => {
  const requestObj = {
    path: `api/member/subscription_list/client`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const cancelSubscriptionsListApi = async (id) => {
  const requestObj = {
    path: `api/member/cancel/subscription/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
